<template>
  <!--<b-dropdown variant="outline-primary" split split-variant="primary" :text="currentLevel">
     <b-dropdown-item v-for="level in getUserDetails.userLevels" :key="level.id" v-on:click="getLevel(level.name, level.level)">{{level.name}}</b-dropdown-item>
  </b-dropdown>-->
  <select v-model="selected" class="form-control user-level-select" v-on:change="getLevel()">
    <option v-for="level in getUserDetails.userLevels" :key="level.level" v-bind:value="{level: level.level, name: level.name}">{{level.name}}</option>
  </select>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
name: 'userlevel',
data(){
    return{
        currentLevel: localStorage.getItem('userLevelName') || 'Newsnet',
        selected: {level: localStorage.getItem('userLevel').toString(), name: localStorage.getItem('userLevelName').toString()}
    }
},
methods:{
    getLevel(){
      //console.log(this.selected)
      let levelValue = this.selected.level
      let levelName = this.selected.name
      localStorage.setItem('userLevel' , levelValue)
      localStorage.setItem('userLevelName' , levelName)
      this.currentLevel = levelName
      this.$store.dispatch('changeNewsnetUserLevel',{
        level: levelValue,
        levelName: levelName
      })
      this.$router.push('/portal')
    }
},
computed:{
    ...mapGetters(['getUserDetails'])
}

}
</script>

<style scoped>
.user-level-select{
  margin-bottom: 5px;
}
</style>
